<template>
  <b-container class="mw-100 mt-3">
    <b-card class="mt-4 mb-4">
      <standard-table :after-search="{cols: 12, sm: 12, md: 12, lg: 12, xl: 12}"
                      :before-pagination="{cols: 12, sm: 12, md: 12, lg: 12, xl: 12}"
                      :fields="fields"
                      :customFields="customFields"
                      :items="items"
                      :row-after-per-page="{cols: 12, sm: 12, md: 12, lg: 3, xl: 1}"

                      :row-after-search="{cols: 12, sm: 12, md: 12, lg: 6, xl: 6, order: 2, orderSm: 3, orderMd: 3, orderLg: 2, orderXl: 2}"
                      :row-before-search="{cols: 12,sm: 12,md: 12,lg: 2,xl: 2,order: 1,orderSm: 1,orderMd: 1,orderLg: 3,orderXl: 3}"
                      :row-between-pagination="{cols: 12, sm: 12, md: 1, lg: 1, xl: 4}"

                      :row-pagination="{cols: 12, sm: 12, md: 6, lg: 5, xl: 5}"
                      :row-per-page="{cols: 12, sm: 12, md: 5, lg: 3, xl: 2}"

                      :row-search="{cols: 12,sm: 12,md: 12,lg: 4,xl: 4,order: 1,orderSm: 2,orderMd: 2,orderLg: 1,orderXl: 1}"
                      :search-label-horizontal="false"
                      :search-place-holder="`${$tc('message.example', 1)}: AA999ZZ`"

                      fullWidth="true"
                      noContainerPadding="true"
                      ref="operationTable"

                      @rowInfo="showInfo($event.item)"
                      @rowEdit="pushToEdit($event.item)"
                      @rowDelete="showInfo($event.item, true)">
        <div slot="active" slot-scope="row">
          <!-- config[crud], create - read - update - delete -->
          <switch-button v-model="row.item.active"
                         v-if="row.item.active ? config.d : config.u"
                         :color="{checked: '#249a80', unchecked: '#dc3545'}"
                         :sync="true"
                         :disabled="row.item.executed"
                         @change="showCheckModal(row.item)"
                         :width="80"
                         id="schedule-executed"
                         :height="32"
                         :font-size="15.5"
                         :speed="500"
                         :labels="true">
            <template slot="checked">
              {{$tc('message.yes', 1)}}
            </template>

            <template slot="unchecked">
              {{$tc('message.no', 1)}}
            </template>
          </switch-button>

          <h6 v-else>
            {{row.item.activeText}}
          </h6>
        </div>

        <b-container class="mw-100 p-0" slot="row-after-search">
          <b-row>
            <b-col cols="auto">
              <b-button class="b-c-green" id="reset-filters" v-on:click="resetFilters()">
                {{$t('message.resetFilters')}}
              </b-button>
            </b-col>

            <b-col class="mb-3" cols="auto">
              <b-button :class="showCollapse ? 'b-c-red' : 'b-c-green'" @click="showCollapse = !showCollapse" id="show-filters">
                <span class="when-opened" v-show="!showCollapse">{{$t('message.show')}} {{$tc('message.filter', 2).toLowerCase()}}</span>
                <span class="when-closed" v-show="showCollapse">{{$t('message.hide')}} {{$tc('message.filter', 2).toLowerCase()}}</span>
              </b-button>
            </b-col>
          </b-row>
        </b-container>

        <b-container class="mw-100 p-0" slot="after-search">
          <b-collapse id="my-collapse" v-model="showCollapse">
            <b-container class="mw-100 m-0 p-0">
              <b-row>
                <b-col cols="12" sm="12" md="6" lg="3" xl="3">
                  <b-form-group :label="`${$tc('message.date', 1)} ${$tc('message.start', 1).toLowerCase()}`"
                                label-for="filter-start">
                    <b-input-group>
                      <flat-pickr :config="startFilterConfig"
                                  :placeholder="`${$tc('message.example', 1)}: ${DateTime.local().toFormat($t('message.dateFormat'))}`"
                                  :readonly="false"
                                  class="form-control"
                                  id="filter-start"
                                  v-model="startFilter">
                      </flat-pickr>

                      <div class="input-group-append">
                        <b-button :disabled="!startFilter"
                                  @click="startFilter = null">
                          <font-awesome-icon icon="trash"/>
                        </b-button>
                      </div>
                    </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="12" md="6" lg="3" xl="3">
                  <b-form-group :label="`${$tc('message.date', 1)} ${$tc('message.end', 1).toLowerCase()}`"
                                label-for="filter-end">
                    <b-input-group>
                      <flat-pickr :config="endFilterConfig"
                                  :placeholder="`${$tc('message.example', 1)}: ${DateTime.local().toFormat($t('message.dateFormat'))}`"
                                  :readonly="false"
                                  class="form-control"
                                  id="filter-end"
                                  v-model="endFilter">
                      </flat-pickr>

                      <div class="input-group-append">
                        <b-button :disabled="!endFilter"
                                  @click="endFilter = null">
                          <font-awesome-icon icon="trash"/>
                        </b-button>
                      </div>
                    </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="12" md="6" lg="3" xl="3">
                  <b-form-group :label="`${$tc('message.section', 1)}`"
                                label-for="input-status">
                    <model-list-select id="input-status"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="entityOptions && entityOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="entityFilter"
                                       :list="entityOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="12" md="6" lg="3" xl="3">
                  <b-form-group :label="`${$tc('message.type', 1)}`"
                                label-for="input-type">
                    <model-list-select id="input-type"
                                       :isDisabled="typeOptions.length <= 1"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="typeOptions && typeOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="typeFilter"
                                       :list="typeOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="12" md="6" lg="3" xl="3">
                  <b-form-group :label="`${$tc('message.reminderGroup', 1)}`"
                                label-for="input-reminderGroup">
                    <model-list-select id="input-reminderGroup"
                                       option-text="descr"
                                       option-value="id"
                                       :placeholder="recipients && recipients.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="reminderFilter"
                                       :list="recipients">
                    </model-list-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="12" md="6" lg="3" xl="3">
                  <b-form-group :label="`${$tc('message.notificationGroup', 1)}`"
                                label-for="input-notificationGroup">
                    <model-list-select id="input-notificationGroup"
                                       option-text="descr"
                                       option-value="id"
                                       :placeholder="recipients && recipients.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="notificationFilter"
                                       :list="recipients">
                    </model-list-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="12" md="6" lg="3" xl="3">
                  <b-form-group :label="`${$tc('message.expired', 1)}`"
                                label-for="input-expired">
                    <model-list-select id="input-expired"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="yesOrNotOptions && yesOrNotOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="expiredFilter"
                                       :list="yesOrNotOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="12" md="6" lg="3" xl="3">
                  <b-form-group :label="`${$tc('message.notified', 1)}`"
                                label-for="input-notified">
                    <model-list-select id="input-notified"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="yesOrNotOptions && yesOrNotOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="notifiedFilter"
                                       :list="yesOrNotOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="12" md="6" lg="3" xl="3">
                  <b-form-group :label="`${$tc('message.enabled', 0)}`"
                                label-for="input-active">
                    <model-list-select id="input-active"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="yesOrNotOptions && yesOrNotOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="activeFilter"
                                       :list="yesOrNotOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-container>
          </b-collapse>
        </b-container>

        <b-container class="mw-100 p-0" slot="row-after-per-page">
          <b-row>
            <b-col>
              <b-button @click="$refs.operationTable.excel($tc('message.notification', 2))" class="float-right mt-3 mt-md-0 mt-lg-0 mt-xl-0" id="excel-button">Excel</b-button>
            </b-col>
          </b-row>
        </b-container>
      </standard-table>
    </b-card>

    <b-modal ref="checkNotificationModal" id="checkNotificationModal" :title="$t('info.infoModal')">
      <b-container>
        <b-row>
          <b-col cols="12" sm="12" md="6" lg="6" xl="6">
            <div class="d-flex">
              <h6><b>{{$tc('message.section', 1)}}:</b></h6>
              <h6 class="ml-2">{{infoItem.entity || $tc('message.emptyValue', 1)}}</h6>
            </div>
          </b-col>

          <b-col cols="12" sm="12" md="6" lg="6" xl="6">
            <div class="d-flex">
              <h6><b>{{$tc('message.type', 1)}}:</b></h6>
              <h6 class="ml-2">{{infoItem.type || $tc('message.emptyValue', 1)}}</h6>
            </div>
          </b-col>

          <b-col cols="12" sm="12" md="12" lg="12" xl="12">
            <div class="d-flex">
              <h6><b>{{$tc('message.reminderGroup', 1)}}:</b></h6>
              <h6 class="ml-2">{{infoItem.reminder || $tc('message.emptyValue', 1)}}</h6>
            </div>
          </b-col>

          <b-col cols="12" sm="12" md="12" lg="12" xl="12">
            <div class="d-flex">
              <h6><b>{{$tc('message.notificationGroup', 1)}}:</b></h6>
              <h6 class="ml-2">{{infoItem.notification || $tc('message.emptyValue', 1)}}</h6>
            </div>
          </b-col>

          <b-col cols="12" sm="12" md="12" lg="12" xl="12">
            <div class="d-flex">
              <h6><b>{{$tc('message.date', 1)}}:</b></h6>
              <h6 class="ml-2">{{infoItem.parsedDate || $tc('message.emptyValue', 1)}}</h6>
            </div>
          </b-col>

          <b-col cols="12" sm="12" md="4" lg="4" xl="4">
            <div class="d-flex">
              <h6><b>{{$tc('message.expired', 1)}}:</b></h6>
              <h6 class="ml-2">{{infoItem.expiredText || $tc('message.emptyValue', 1)}}</h6>
            </div>
          </b-col>

          <b-col cols="12" sm="12" md="4" lg="4" xl="4">
            <div class="d-flex">
              <h6><b>{{$tc('message.notified', 1)}}:</b></h6>
              <h6 class="ml-2">{{infoItem.notifiedText || $tc('message.emptyValue', 1)}}</h6>
            </div>
          </b-col>

          <b-col cols="12" sm="12" md="4" lg="4" xl="4" v-if="isInfoModal">
            <div class="d-flex">
              <h6><b>{{$tc('message.enabled', 0)}}:</b></h6>
              <h6 class="ml-2">{{infoItem.activeText || $tc('message.emptyValue', 1)}}</h6>
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <div class="d-flex">
              <h6><b>{{$tc('message.message', 1)}}:</b></h6>
              <h6 class="ml-2">{{infoItem.message || $tc('message.emptyValue', 1)}}</h6>
            </div>
          </b-col>
        </b-row>

        <b-row v-if="!isInfoModal">
          <b-col>
            <h4 class="c-red">
              {{$tc('info.areYouSureTo', 1)}}
              {{infoItem.active? $tc('message.enabling', 0).toLowerCase() : $tc('message.disabling', 0).toLowerCase()}}
              {{$tc('message.theNotification', 1).toLowerCase()}}?
            </h4>
          </b-col>
        </b-row>
      </b-container>

      <div slot="modal-footer" class="w-100 justify-content-end d-flex">
        <b-button class="b-c-green mr-3"
                  v-if="!isInfoModal"
                  v-on:click="updateItem(infoItem, true)">
          {{$tc('message.continue', 1)}}
        </b-button>

        <b-button class="b-c-green"
                  v-if="!isInfoModal"
                  v-on:click="updateItem(infoItem)">
          {{$tc('message.close', 1)}}
        </b-button>

        <b-button class="b-c-green"
                  v-if="isInfoModal"
                  v-on:click="hideCheckModal()"> Ok
        </b-button>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import { cloneDeep, find, first, orderBy, split, filter, concat } from 'lodash'
import { DateTime } from 'luxon'
import { Italian } from 'flatpickr/dist/l10n/it.js'
import Vue from 'vue'
import notificationType from '../../plugins/notification-field-name'

export default {
  name: 'Scheduling',
  created () {
    this.fetchData()
  },
  mounted () {
    this.$root.$on('change-lang', () => {
      if (this.$el.isConnected) {
        this.getStaticOptions()
        this.refreshItems()
      }
    })
    this.$root.$on('resize', size => {
      if (this.$el.isConnected) {
        this.size = size
        this.isMobile = size !== 'md' && size !== 'lg' && size !== 'xl'
        this.getFields()
      }
    })
  },
  data () {
    const genericDateConfig = {
      dateFormat: 'Y-m-d',
      mode: 'single',
      altFormat: 'D j M Y',
      altInput: true,
      locale: Italian,
      minDate: '',
      maxDate: '',
      disable: []
    }
    const config = this.$route.meta.config

    return {
      config,
      DateTime,
      originalItems: [],
      items: [],
      fields: [],
      customFields: [],
      yesOrNotOptions: [],
      operationEnum: [],
      serviceEnum: [],
      ownershipEnum: [],
      entityOptions: [],
      typeOptions: [],
      originalRecipients: [],
      recipients: [],
      startFilterConfig: cloneDeep(genericDateConfig),
      endFilterConfig: cloneDeep(genericDateConfig),
      startFilter: null,
      endFilter: null,
      entityFilter: '',
      typeFilter: '',
      reminderFilter: '',
      notificationFilter: '',
      expiredFilter: '',
      notifiedFilter: '',
      activeFilter: '',
      showCollapse: false,
      infoItem: {},
      isMobile: false,
      isInfoModal: true,
      size: 'xl'
    }
  },
  watch: {
    startFilter (val) {
      const parsedVal = new Date(val)
      this.endFilterConfig.disable = [dateObj => {
        return val ? dateObj < parsedVal : false
      }]

      this.fetchData()
    },
    endFilter (val) {
      const parsedVal = new Date(val)
      this.startFilterConfig.disable = [dateObj => {
        return val ? dateObj > parsedVal : false
      }]

      this.fetchData()
    },
    entityFilter (val) {
      this.typeOptions = []
      const typeOptions = new Set()
      if (!val || val === '') this.typeFilter = ''

      this.items = this.getItems('entity', val)

      this.items.forEach(item => {
        typeOptions.add(item.type)
      })

      this.typeOptions.push({ value: '', text: this.$tc('message.all', 1) })
      Array.from(typeOptions).forEach((item, index) => {
        this.typeOptions.push({ value: index, text: item })
      })
    },
    typeFilter (val) {
      this.items = this.getItems('type', val)
    },
    reminderFilter (val) {
      this.items = this.getItems('reminder', val)
    },
    notificationFilter (val) {
      this.items = this.getItems('notification', val)
    },
    expiredFilter (val) {
      this.items = this.getItems('expired', val)
    },
    notifiedFilter (val) {
      this.items = this.getItems('notified', val)
    },
    activeFilter (val) {
      this.items = this.getItems('active', val)
    }
  },
  methods: {
    getOptions () {
      const axiosArray = []
      axiosArray.push(this.getRecipients())
      axiosArray.push(this.getEnum('operation', 'operationEnum', true))
      axiosArray.push(this.getEnum('service_type', 'serviceEnum', true))

      return Vue.myAll(axiosArray).then(() => {
        this.getStaticOptions()
        return true
      })
    },
    getStaticOptions () {
      this.getFields()
      this.getYesOrNot()
      this.getOwnershipTypeOptions()
      this.updateRecipients()
    },
    getOwnershipTypeOptions () {
      this.ownershipEnum = [
        { value: '', text: this.$t('message.selectOption') },
        { value: 'rental', text: this.$tc('message.rental', 1) },
        { value: 'leasing', text: 'Leasing' },
        { value: 'property', text: this.$tc('message.property', 1) },
        { value: 'loan', text: this.$tc('message.loan', 1) }
      ]
    },
    getEnum (path, obj, selectionMessage) {
      const options = []
      return Vue.myGet(this, `/enums/${path}`, 'data').then((items) => {
        if (selectionMessage) {
          options.push({ value: '', text: items.length !== 0 ? this.$t('message.selectOption') : this.$t('message.noOption') })
        }
        items.forEach((item) => {
          options.push({ value: item.id, text: item.descr })
        })
        if (obj) {
          this[obj] = options
        }
        return options
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        return false
      })
    },
    getFields () {
      this.fields = [
        // config[crud], create - read - update - delete
        { key: 'edit', label: '', hideInTable: !this.config.u && !this.config.r },
        { key: 'info', label: '', hideInTable: !this.config.r },
        { key: 'entity', label: this.$tc('message.section', 1), sortable: true, sortDirection: 'desc' },
        { key: 'type', label: this.$tc('message.type', 1), sortable: true, sortDirection: 'desc' },
        { key: 'parsedDate', label: this.$tc('message.date', 1), sortable: true, sortDirection: 'desc' },
        { key: 'reminder', label: this.$tc('message.reminderGroup', 1), sortable: true, sortDirection: 'desc', hideInTable: this.size !== 'xl' },
        { key: 'notification', label: this.$tc('message.notificationGroup', 1), sortable: true, sortDirection: 'desc', hideInTable: this.size !== 'xl' },
        { key: 'expiredText', label: this.$tc('message.expired', 1), sortable: true, sortDirection: 'desc' },
        { key: 'notifiedText', label: this.$tc('message.notified', 1), sortable: true, sortDirection: 'desc' },
        { key: 'activeText', label: this.$tc('message.enabled', 0), sortable: true, sortDirection: 'desc', hideInTable: true },
        { key: 'messageEdited', label: this.$tc('message.message', 1), sortable: true, sortDirection: 'desc', hideInTable: true }
      ]
      this.customFields = [
        { key: 'active', label: this.$tc('message.enabled', 0) },
        { key: 'message', label: '', hideInTable: true, hideInExcel: true }
      ]
    },
    getRecipients () {
      Vue.myGet(this, '/recipients_list', 'recipients').then(recipients => {
        const editedItems = []
        recipients.forEach(group => {
          const editedGroup = group
          editedGroup.mailString = ''
          group.recipients.forEach((recipient, index) => {
            editedGroup.mailString += `${recipient}${index + 1 === group.recipients.length ? '' : ', '}`
          })
          editedItems.push(editedGroup)
        })
        this.originalRecipients = orderBy(editedItems, 'descr')
      })
    },
    updateRecipients () {
      this.recipients = concat([{ id: '', descr: this.$tc('message.all', 1) }], cloneDeep(this.originalRecipients))
    },
    getYesOrNot () {
      this.yesOrNotOptions = [
        { value: '', text: this.$tc('message.all', 1) },
        { value: 0, text: this.$tc('message.no', 1) },
        { value: 1, text: this.$tc('message.yes', 1) }
      ]
    },
    fetchData () {
      this.$root.$emit('activeLoader', true)
      this.getOptions().then(() => {
        this.getSchedulingItems().then(() => {
          this.refreshItems()
          this.$root.$emit('activeLoader', false)
        })
      })
    },
    getSchedulingItems () {
      const start = `start_date=${this.startFilter}`
      const end = `end_date=${this.endFilter}`
      const hasDates = !!this.startFilter && !!this.endFilter
      const url = `/scheduling${hasDates ? '?' : ''}${hasDates ? start : ''}${hasDates ? '&' + end : ''}`

      return Vue.myGet(this, url, 'events').then(events => {
        this.originalItems = events
        return true
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        return false
      })
    },
    refreshItems () {
      const recipients = this.recipients
      const items = cloneDeep(this.originalItems)
      const editedItems = []

      const entityOptions = new Set()

      items.forEach(item => {
        const editedItem = item
        editedItem.entity = this.$tc(`message.${item.srcEntity}`, 1)
        editedItem.parsedDate = item.date ? DateTime.fromSQL(item.date).toFormat('dd-MM-y') : this.$tc('message.emptyValue')
        editedItem.notifiedText = this.$tc(`message.${item.notified ? 'yes' : 'no'}`, 1)
        editedItem.activeText = this.$tc(`message.${item.active ? 'yes' : 'no'}`, 1)
        editedItem.expiredText = this.$tc(`message.${item.expired ? 'yes' : 'no'}`, 1)
        editedItem.messageEdited = item.message

        if (item.reminderRecipientId) {
          const foundedRecipient = find(recipients, obj => obj.id === item.reminderRecipientId)
          if (foundedRecipient) editedItem.reminder = foundedRecipient.descr
        }
        if (item.notificationRecipientId) {
          const foundedRecipient = find(recipients, obj => obj.id === item.notificationRecipientId)
          if (foundedRecipient) editedItem.notification = foundedRecipient.descr
        }
        editedItem.type = this.findType(item.srcFieldName)

        entityOptions.add(editedItem.entity)

        editedItems.push(editedItem)
      })

      this.entityOptions = [{ value: '', text: this.$tc('message.all', 1) }]
      Array.from(entityOptions).forEach((entity, index) => {
        this.entityOptions.push({ value: index, text: entity })
      })

      this.items = editedItems
      return cloneDeep(this.items)
    },
    findType (srcFieldName) {
      const selector = first(split(srcFieldName, '='))
      const id = split(srcFieldName, '=')[1]
      let result = null

      switch (selector) {
        case notificationType.OPERATION.TYPE:
          result = find(this.operationEnum, obj => obj.value === id).text
          break

        case notificationType.SERVICES.TYPE:
          result = find(this.serviceEnum, obj => obj.value === id).text
          break

        case notificationType.OWNERSHIP.TYPE:
          result = find(this.ownershipEnum, obj => obj.value === id).text
          break

        default:
          break
      }

      return result
    },
    showInfo (item) {
      this.isInfoModal = true
      this.infoItem = item
      this.$refs.checkNotificationModal.show()
    },
    pushToEdit (item) {
      const entity = item.srcEntity
      const path = entity === 'operation'
        ? '/organization/operation/:id'
        : '/organization/registry_vehicles/:id'
      const permission = Vue.getConfigByRouteItem({ path })

      // config[crud], create - read - update - delete
      if (permission && permission.config && permission.config.r) {
        if (entity === 'operation') {
          Vue.myGet(this, `/operations?vehicle=${item.srcObjectId}`, 'operations').then(operations => {
            const operation = find(operations, o => {
              const type = split(item.srcFieldName, '=')[1]

              return (o.plannedKm && item.km ? o.plannedKm === item.km : (!o.plannedKm && !item.km)) &&
                (o.plannedDate && item.date ? o.plannedDate === item.date : (!o.plannedDate && !item.date)) &&
                o.plannedDate === item.date && o.type === type
            })

            if (operation) {
              this.$router.push(`/organization/operation/${operation.id}?vehicle=${item.srcObjectId}`)
            } else {
              Vue.error(this, this.$tc('dimetiorHttpCode.422.3', 1))
            }
          }).catch(error => {
            Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
          })
        } else {
          const type = first(split(first(split(item.srcFieldName, '=')), '.'))
          const tab = type === 'services' ? 'services' : 'vehicleUsage'
          this.$router.push(`/organization/registry_vehicles/${item.srcObjectId}?tab=${tab}`)
        }
      } else {
        Vue.error(this, this.$t('message.pathNotActive'))
      }
    },
    resetFilters () {
      this.startFilter = null
      this.endFilter = null
      this.entityFilter = ''
      this.typeFilter = ''
      this.reminderFilter = ''
      this.notificationFilter = ''
      this.expiredFilter = ''
      this.notifiedFilter = ''
      this.activeFilter = ''
    },
    showCheckModal (item) {
      this.isInfoModal = false
      this.infoItem = item
      this.$refs.checkNotificationModal.show()
    },
    hideCheckModal () {
      this.$refs.checkNotificationModal.hide()
    },
    updateItem (item, update) {
      if (update) {
        this.$root.$emit('activeLoader', true)
        const entity = item.srcEntity
        const path = entity === 'operation'
          ? `/operations/${item.srcObjectId}`
          : `/vehicles/${item.srcObjectId}`
        const deeperObject = entity === 'operation' ? 'operations' : 'vehicles'
        const editedItem = cloneDeep(item)
        const today = DateTime.local()

        this.fields.forEach(field => {
          if (editedItem[field]) delete editedItem[field]
        })

        Vue.myGet(this, path, deeperObject).then(result => {
          let goAhead = true
          if (DateTime.fromFormat(item.date, 'yyyy-MM-dd') < today && !!item.active) {
            Vue.error(this, this.$tc('info.schedulingDateIsLessThanToday', 1))
            goAhead = false
          }
          if (deeperObject === 'vehicles' && result.disablingDate && DateTime.fromSQL(result.disablingDate) > today) {
            Vue.error(this, this.$tc('info.vehicleAlreadyDisabled', 1))
            goAhead = false
          }

          if (goAhead) {
            Vue.putOrPost(this, true, `/scheduling/${item.id}`, editedItem).then(() => {
              this.$root.$emit('activeLoader', false)
              const newStatus = editedItem.active ? this.$tc('message.enabled', 3).toLowerCase() : this.$tc('message.disabled', 3).toLowerCase()
              Vue.success(this, `${this.$tc('message.notification', 1)} ${newStatus}`)
              this.hideCheckModal()
            }).catch(error => {
              Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
              this.$root.$emit('activeLoader', false)
              item.active = !item.active
              this.hideCheckModal()
            })
          } else {
            this.$root.$emit('activeLoader', false)
            item.active = !item.active
            this.hideCheckModal()
          }
        }).catch(error => {
          Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
          this.$root.$emit('activeLoader', false)
          item.active = !item.active
          this.hideCheckModal()
        })
      } else {
        item.active = !item.active
        this.hideCheckModal()
      }
    },
    getItems (field, val) {
      let items = this.refreshItems()
      const entity = field === 'entity' ? val : this.entityFilter
      const type = field === 'type' ? val : this.typeFilter
      const reminder = field === 'reminder' ? val : this.reminderFilter
      const notification = field === 'notification' ? val : this.notificationFilter
      const expired = field === 'expired' ? val : this.expiredFilter
      const notified = field === 'notified' ? val : this.notifiedFilter
      const active = field === 'active' ? val : this.activeFilter

      if (entity !== '') items = filter(items, obj => obj.entity === find(this.entityOptions, o => o.value === entity).text)
      if (type !== '') items = filter(items, obj => obj.type === find(this.typeOptions, o => o.value === type).text)
      if (reminder !== '') items = filter(items, obj => obj.reminder === find(this.recipients, o => o.id === reminder).descr)
      if (notification !== '') items = filter(items, obj => obj.notification === find(this.recipients, o => o.id === notification).descr)
      if (expired !== '') items = filter(items, obj => obj.expiredText === find(this.yesOrNotOptions, o => o.value === expired).text)
      if (notified !== '') items = filter(items, obj => obj.notifiedText === find(this.yesOrNotOptions, o => o.value === notified).text)
      if (active !== '') items = filter(items, obj => obj.activeText === find(this.yesOrNotOptions, o => o.value === active).text)

      return items
    }
  }
}
</script>
